import React from "react";

const FTFRFailures = ({ title, description, failures }) => {
  return (
    <section className="ftfr-failures-section">
      <div className="container">
        <div
          className="text-center mb-5"
          data-aos="fade-up"
          data-aos-once="true"
        >
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="row g-4">
          {failures.map((failure, i) => (
            <div
              key={i}
              className="col-md-6"
              data-aos="fade-up"
              data-aos-delay={`${i * 100}`}
              data-aos-once="true"
            >
              <div className="ftfr-failure-card">
                <p className="ftfr-failure-title">{failure.title}</p>
                <p className="ftfr-failure-desc">{failure.description}</p>
                <p className="ftfr-failure-prevention">
                  <strong>Prevention:</strong> {failure.prevention}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FTFRFailures;
